var _CUSTOM_COD_FORM_PROVINCES = {
  data: {"ANTIOQUIA":{"AMAGA":true,"BARBOSA":true,"BELLO":true,"CALDAS":true,"CAREPA":true,"CIUDAD BOLIVAR":true,"COPACABANA":true,"DON MATIAS":true,"EL CARMEN DE VIBORAL":true,"EL SANTUARIO":true,"ENVIGADO":true,"GIRARDOTA":true,"GUARNE":true,"ITAGUI":true,"LA CEJA":true,"LA ESTRELLA":true,"MARINILLA":true,"MEDELLIN":true,"PEÑOL":true,"PUERTO BERRIO":true,"RETIRO":true,"SABANETA":true,"SAN JERONIMO":true,"SAN PEDRO DE LOS MILAGROS":true,"SANTA ROSA DE OSOS":true,"YARUMAL":true},"ATLANTICO":{"BARRANQUILLA":true,"CANDELARIA":true,"PALMAR DE VARELA":true,"PUERTO COLOMBIA":true},"BOYACA":{"CHIQUINQUIRA":true,"COMBITA":true,"CUCAITA":true,"DUITAMA":true,"GARAGOA":true,"GUATEQUE":true,"MONIQUIRA":true,"NOBSA":true,"PAIPA":true,"RAMIRIQUI":true,"SABOYA":true,"SACHICA":true,"SAMACA":true,"SANTA ROSA DE VITERBO":true,"SOGAMOSO":true,"SUTAMARCHAN":true,"TIBASOSA":true,"TINJACA":true,"TUNJA":true,"TUTA":true,"VILLA DE LEYVA":true},"CALDAS":{"CHINCHINA":true,"MANIZALES":true,"RIOSUCIO":true,"SUPIA":true,"VILLAMARIA":true,"VITERBO":true},"CASANARE":{"AGUAZUL":true,"MONTERREY":true,"TAURAMENA":true,"YOPAL":true},"CAUCA":{"POPAYAN":true,"SANTANDER DE QUILICHAO":true},"CESAR":{"AGUACHICA":true,"CHIRIGUANA":true,"PAILITAS":true,"RIO DE ORO":true,"VALLEDUPAR":true},"CORDOBA":{"CERETE":true,"CIENAGA DE ORO":true,"LORICA":true,"PLANETA RICA":true,"PUEBLO NUEVO":true,"SAHAGUN":true,"SAN PELAYO":true},"CUNDINAMARCA":{"ANAPOIMA":true,"BOGOTA":true,"CAJICA":true,"CHIA":true,"COGUA":true,"COTA":true,"EL ROSAL":true,"FACATATIVA":true,"FUNZA":true,"FUSAGASUGA":true,"GACHANCIPA":true,"GIRARDOT":true,"GUADUAS":true,"LA CALERA":true,"LA MESA":true,"LA VEGA":true,"MADRID":true,"MOSQUERA":true,"PUERTO SALGAR":true,"SIBATE":true,"SOACHA":true,"SOPO":true,"SUBACHOQUE":true,"TABIO":true,"TAUSA":true,"TENJO":true,"TOCAIMA":true,"TOCANCIPA":true,"VILLETA":true,"ZIPAQUIRA":true},"HUILA":{"CAMPOALEGRE":true,"GARZON":true,"GIGANTE":true,"HOBO":true,"LA PLATA":true,"NEIVA":true,"PAICOL":true,"RIVERA":true,"SAN AGUSTIN":true,"TESALIA":true,"TIMANA":true},"META":{"ACACIAS":true,"CUMARAL":true,"VILLAVICENCIO":true},"NARIÑO":{"IPIALES":true,"SANDONA":true},"NORTE DE SANTANDER":{"CUCUTA":true,"LOS PATIOS":true,"OCAÑA":true,"PAMPLONA":true,"VILLA DEL ROSARIO":true},"QUINDIO":{"CALARCA":true,"CIRCASIA":true,"FILANDIA":true,"LA TEBAIDA":true,"MONTENEGRO":true,"QUIMBAYA":true},"RISARALDA":{"BELEN DE UMBRIA":true,"DOSQUEBRADAS":true,"GUATICA":true,"LA VIRGINIA":true,"PEREIRA":true,"QUINCHIA":true,"SANTA ROSA DE CABAL":true},"SANTANDER":{"BARRANCABERMEJA":true,"BUCARAMANGA":true,"CHARALA":true,"CURITI":true,"FLORIDABLANCA":true,"GIRON":true,"GUEPSA":true,"LEBRIJA":true,"MALAGA":true,"OIBA":true,"PIEDECUESTA":true,"PINCHOTE":true,"PUENTE NACIONAL":true,"SAN GIL":true,"SAN VICENTE DE CHUCURI":true,"SOCORRO":true,"VELEZ":true,"ZAPATOCA":true},"SUCRE":{"COROZAL":true,"SAN PEDRO":true,"SINCELEJO":true},"TOLIMA":{"ALVARADO":true,"CAJAMARCA":true,"CHICORAL":true,"ESPINAL":true,"FLANDES":true,"FRESNO":true,"HONDA":true,"IBAGUE":true,"LERIDA":true,"LIBANO":true,"MELGAR":true,"NATAGAIMA":true,"ORTEGA":true,"PRADO":true,"ROVIRA":true,"SALDAÑA":true,"VILLAHERMOSA":true},"VALLE":{"ALCALA":true,"ANDALUCIA":true,"BUGA":true,"BUGALAGRANDE":true,"CAICEDONIA":true,"CALI":true,"CARTAGO":true,"EL CERRITO":true,"FLORIDA":true,"GINEBRA":true,"GUACARI":true,"JAMUNDI":true,"LA PAILA":true,"OBANDO":true,"PALMIRA":true,"PRADERA":true,"ROLDANILLO":true,"TORO":true,"TULUA":true,"VIJES":true,"VILLA GORGONA":true,"YUMBO":true,"ZARZAL":true}},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var html = "";
    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      return;
    }
    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
  }
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
    var html = "";
    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }
    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";
        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
          html += '<option value="' + item + '">' + item + '</option>';
        });
        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }
    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }
    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [{
        label: _COD_FORM_PROVINCE_LABEL,
        value: "",
      }];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    }
  });
  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }
  return true;
}